import React, { useEffect, useState } from 'react'
import essTeamServices from '../essTeamServices';
import EssLayout from '../../../../layout/components/ESSLayout';
import { CircularProgress } from '@mui/material';
import moment from 'moment';
import { useAlert } from '../../../../context/AlertContext';
import EssTeamLeaveRequest from '../components/EssTeamLeaveRequest';
import useGeolocation from '../../../../hooks/useGeolocation';
import { Link } from 'react-router-dom';
import { LocationOff, PinDrop, Verified, Warning } from '@mui/icons-material';

function EssTeamListPage() {

  const [loading,setLoadingStatus] = useState(false);
  const [saving,setSavingStatus] = useState(false);
  const [attendanceList,setAttendanceList] = useState(null);
  const {AppAlert} = useAlert();
  const { getLocation, locatingLoading, geoLocationError,location } = useGeolocation();

  const getAttendanceList = () =>{
    setLoadingStatus(true);
    essTeamServices.getAttendanceList().then(res=>{
      setAttendanceList(res.data);
    }).catch(error=>{

    }).finally(()=>{
      setLoadingStatus(false);
    })
  }

  useEffect(()=>{
    getAttendanceList();
  },[])  


  const punch = async (employee) =>{
    setSavingStatus(true);
    // 1. Get the fresh location directly from the promise resolution
    const coords = await getLocation();

    if (!coords) {
        // If location retrieval failed or was denied, getLocation already handled the error message
        setSavingStatus(false);
        return;
    }
    
    let payload = {
        employeeId:employee.id,
        lat: parseFloat(coords.lat.toFixed(6)),
        lng: parseFloat(coords.lng.toFixed(6))
    }
      if(employee.punch !== null){
        payload.punchId = employee.punch.id;
        payload.inTime = employee.punch.inTime
      }
      
      essTeamServices.managerDoPunch(payload).then(res=>{
          AppAlert(res.msg)
          getAttendanceList();
      }).catch((error)=>{
        AppAlert(error.msg,"error")
      }).finally(()=>{
        setSavingStatus(false)
      })
  }

  return (
    <EssLayout>
      <div className='row'>
        <div className='col-md-12'>
          <span className='float-end'><EssTeamLeaveRequest /></span>
        </div>
      </div>
      <div className='row'>
          {attendanceList && attendanceList.map(employee=>
            <div className='col-md-4' key={employee.id}>
              <div className='card shadow  mt-3'>
                <div className='card-body'>
                  <div className='fw-bold'>{employee.employeeName}</div>
                  <div className=''>{employee.employeeCode}</div>
                </div>
                <div className='card-footer'>
                    {employee.punch === null ?
                        <div>
                          {saving ? 
                            <CircularProgress/>
                            :
                            <button className="btn btn-success float-end" onClick={()=>punch(employee)}>Punch In</button>
                          }
                        </div>
                      :
                      <div>
                        <span >{moment(employee.punch.inTime).format("HH:mm A")}</span>
                        {employee.punch.inLat && employee.punch.inLng ? (
                            <Link to={`https://www.google.com/maps/search/?api=1&query=${employee.punch.inLat},${employee.punch.inLng}`} target="_blank" rel="noopener noreferrer">
                              <span className='ms-2'><PinDrop /></span>
                            </Link>
                          ) : (
                            <span className='ms-2'><LocationOff /></span>
                          )
                        }
                        {employee.punch.inStatus ? <Verified color='success' fontSize='small' /> : <Warning color='warning' fontSize='small' />}
                        
                        {employee.punch.outTime === null ?
                          <>
                            {saving? 
                              <CircularProgress/>
                              :
                              <button className="btn btn-warning float-end" onClick={()=>punch(employee)}>Punch Out</button>
                            }
                          </>
                          :
                            <>
                              <span className='float-end ms-2'>
                                {employee.punch.outLat && employee.punch.outLng ? (
                                  <Link to={`https://www.google.com/maps/search/?api=1&query=${employee.punch.outLat},${employee.punch.outLng}`} target="_blank" rel="noopener noreferrer">
                                    <span className='ms-2'><PinDrop /></span>
                                  </Link>
                                ) : (
                                  <span className='ms-2'><LocationOff /></span>
                                )
                                }
                                {employee.punch.outStatus ? <Verified color='success' fontSize='small' /> : <Warning color='warning' fontSize='small' />}
                                </span>
                              <span className='float-end'>{moment(employee.punch?.outTime).format("HH:mm A")}</span>
                            </>
                        }
                      </div>
                      
                    }
                  
                </div>
              </div>
            </div>
          )}
      </div>
      <div className='row'>
        { /* JSON.stringify(attendanceList) */}
      </div>
    </EssLayout>
  )
}

export default EssTeamListPage